import React, { useEffect, useState } from 'react'
import Modal from 'components/modal'
import ICSelect from 'containers/project-creation/create-view/select'
import { sortAlphabetically } from 'shared/helpers/functional'
import 'less/translations-modal.less'


const TranslationsModal = props => {
    const [language, setLanguage] = useState('Select language')
    const [languageCode, setLanguageCode] = useState('')
    const [localization, setLocalization] = useState('Default (No Country Selected)')
    const [localizationCode, setLocalizationCode] = useState('')
    const [localizationPlaceholder, setLocalizationPlaceholder] = useState('')
    const [localizationValue, setLocalizationValue] = useState()


    const localizationMap = props.localizationMap && [...props.localizationMap.values()]
    const localizationMapSorted = sortAlphabetically(localizationMap)
    const localisationAvailable = localizationMap && localizationMap.filter(item => item.language_code === languageCode).length > 0
    const languageArray = props.languages && props.languages.size > 0 && [...props.languages.values()];
    const languageArraySorted = languageArray &&  sortAlphabetically(languageArray)
      
    const setLanguageAndCode = (value) => {
        setLanguageCode(value.value)
        setLanguage(value.label)
    }

    const setLocalizationAndCode = (value) => {
        setLocalizationPlaceholder(value.label)
        setLocalizationValue(value.value)
        setLocalizationCode(value.value)
        setLocalization(value.label)
    }

    useEffect(() => {
        if (localizationMap[0] && localisationAvailable) {
            setLocalizationPlaceholder(localizationMap[0].country + " (" + localizationMap[0].country_code + ")")
            setLocalizationValue(localizationMap[0].id)
            setLocalizationCode(localizationMap[0].country_code)
            setLocalization(localizationMap[0].id)
        }
    }, [localisationAvailable])


    useEffect(() => {
        if (!localisationAvailable) {
            setLocalizationCode("")
            setLocalization("")
        }
    }, [localisationAvailable])

    return (
        <Modal
            title={"Add Translation"}
            isOpen={props.isOpen}
            className="confirmation-modal translations-modal"
            type="modal"
            autoFocusSubmit={false}
            submitBtnText="Add Translation"
            cancelBtnText="Cancel"
            onCancel={props.onCancel}
            onSubmit={() => props.onSubmit({ language: language, languageCode: languageCode, localization: localization, localizationCode: localizationCode , editedConferenceLink: props.editedConferenceLink, editedMeetingInformation: props.editedMeetingInformationMap, flag:props.flag, editedTopicName:props.editedTopicName
            })}
        >
            <div className="translations-modal-body">
                <div className="translations-modal-text">
                    <p> {props.t('translations.modal.message')}</p>
                </div>
                <div className='translations-container'>
                    <div className='language-container'>
                        <div className='language-title'>Language</div>
                        <ICSelect
                            disabled={false}
                            placeholder={language}
                            options={languageArraySorted && languageArraySorted.length !== 0 ? languageArraySorted.map((value) => ({ value: value.language_code, label: `${value.language_name + " (" + value.language_code + ")"}` })) : []}
                            value={languageArraySorted && languageArraySorted.id}
                            onChange={e => setLanguageAndCode(e)}
                            className='select-language'
                        />
                    </div>
                    <div className='localization-container'>
                        <div className='localization-title'> {props.t('localization.header')}</div>
                        <ICSelect
                            disabled={!localisationAvailable}
                            placeholder={localisationAvailable ? localizationPlaceholder : 'Default (No Country Selected)'}
                            options={localisationAvailable ? localizationMapSorted.length !== 0 && localizationMapSorted.map(value => ({ value: value.country_code, label: `${value.country + " (" + value.country_code + ")"}` })) : []}
                            value={localisationAvailable ? localizationValue : -1}
                            onChange={e => localisationAvailable ? setLocalizationAndCode(e) : 'Default (No Country Selected)'}
                            className='select-localization'
                        />
                    </div>
                </div>
            </div>
        </Modal>
    )
}
export default TranslationsModal
